module.exports = __webpack_public_path__ + "img/VISA.e45e4587.svg";